import type { UserAvatar } from '../../../api/people';
import { uiText } from '../../../i18n';
import { studioApi, type StudioApp } from '../../studio/studio-api';
import { useStudioDocument } from '../../studio/use-studio-document';
import { textPolicy } from './text-model';
import { TextOrderForm } from './TextOrderForm';
import { StudioZero } from '../../studio/StudioZero';
export function TextEntryForm(props: { app: StudioApp; avatar: UserAvatar | null; initialInputs?: Record<string, unknown> }) {
  const probe = useStudioDocument(signal => studioApi.form(props.app.id, signal), `text-entry:${props.app.id}`);
  if (probe.loading) return <p role="status">{uiText('Загружаем…')}</p>;
  /* Форму не получили — показываем оформленную сцену, а не строку текста: на весь экран создания
     висела одна строка «Создание сейчас недоступно Повторить». Вид тот же, что у StudioScreen,
     когда экрана для инструмента нет вовсе. */
  if (!probe.data || probe.error || probe.data.app_id !== props.app.id)
    return (
      <StudioZero
        title="Создание сейчас недоступно"
        text={uiText('Попробуйте ещё раз или вернитесь к шаблонам.')}
        action={{ label: 'Повторить', icon: 'arrow', onClick: probe.reload }}
      />
    );
  return textPolicy(probe.data) ? (
    <TextOrderForm {...props} />
  ) : (
    <StudioZero title="Создание сейчас недоступно" text={uiText('Выберите другой инструмент или вернитесь к шаблонам.')} />
  );
}
